<template>
	<section class="main-content benefits">
		<div class="row">
			<div class="columns column4">
				<h2 class="subtitle">{{ subtitle }}</h2>
				<h2>{{ title }}</h2>
				<ul>
					<li v-for="(benefit, key) in benefits" :key="key">
						<span>{{ benefit }}</span>
					</li>
				</ul>
				<book-button class="button button-cta reserve-now">
					<span>{{ buttonText }}</span>
				</book-button>
			</div>
		</div>
		<picture v-if="image.image">
			<source v-if="image.imageWebp" :srcset="image.imageWebp" type="image/webp" />
			<source :srcset="image.image" />
			<img class="fade-image" :src="image.image" :alt="image.imageAlt" loading="lazy" />
		</picture>
	</section>
</template>

<script setup lang="ts">
defineProps<{
	title: string;
	subtitle: string;
	benefits: string[];
	buttonText: string;
	image: {
		image: string | null;
		imageAlt: string;
		imageWebp: string | null;
	};
}>();
</script>

<style lang="scss" scoped>
.benefits .fade-image {
	opacity: 1;
}

.benefits {
	position: relative;
	padding: 75px 0;
}

.benefits .row {
	z-index: 2;
	position: relative;
}

.benefits .column4 {
	background: rgb(249 246 242 / 80%);
	box-shadow: 0 18px 18px rgb(0 0 0 / 25%);
	backdrop-filter: blur(34px);
	padding: 60px 50px;
}

.benefits ul {
	list-style: none;
	font-size: 20px;
	margin: 30px 0;
	padding-left: 0;
}

.benefits li {
	position: relative;
	display: flex;
	flex-wrap: nowrap;
	align-items: center;
	margin: 20px 0;

	span {
		width: calc(100% - 70px);
	}
}

.benefits li::before {
	content: '';
	background: url('~/assets/images/icon-check.png') no-repeat center center;
	background-size: 40px;
	height: 40px;
	width: 40px;
	display: block;
	margin: 0 30px 0 0;
}

@media (max-width: 1180px) {
	.benefits .column4 {
		width: 50%;
	}
}

@media (max-width: 920px) {
	.benefits {
		ul {
			font-size: 18px;
		}

		.column4 {
			width: 100%;
		}
	}
}

@media (max-width: 800px) {
	.benefits {
		ul {
			font-size: 16px;
		}

		li::before {
			margin: 0 10px 0 0;
		}
	}
}
</style>
